module.exports = __webpack_public_path__ + "img/introduce-bg.44446d80.png";